/* Shallow-Sea Daydream - the only thing the blocks genuinely need script for is
   measuring how far a bubble has to travel to clear its card. Everything else
   (bobbing, opening shells, revealing names on hover) is pure CSS so the page
   still reads correctly with JS disabled. */
(function () {
  var fields = document.querySelectorAll('.dd-bubble-field');
  if (!fields.length) return;

  function size() {
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var card = field.parentElement;
      if (!card) continue;
      // measure the field, not the card: since the tile went circular the card
      // is taller than the bubble (it includes the name/price underneath), and
      // sizing off the card sent the motes sailing past the top edge
      var h = field.getBoundingClientRect().height || card.getBoundingClientRect().height || 300;
      field.style.setProperty('--dd-rise', Math.round(h + 26) + 'px');
    }
  }

  size();

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(size, 180);
  });

  // bubbles are decorative and animated forever - stop the clock while off screen
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          e.target.querySelectorAll('.dd-bubble').forEach(function (b) {
            b.style.animationPlayState = e.isIntersecting ? 'running' : 'paused';
          });
        });
      },
      { rootMargin: '160px 0px' }
    );
    fields.forEach(function (f) { io.observe(f); });
  }
})();
